module.exports = __webpack_public_path__ + "std/img/raffle-rule-bg.aa1f526.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/raffle-rule-bg.webp
// module id = SijZ
// module chunks = 0 5